export default __webpack_public_path__ + "node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2";